import React from "react";
import { useDebridement } from "./hooks/useDebridement";
import ConfirmationModal from "../../../secondary/ConfirmationModal/ConfirmationModal";
import { DebridementEditMode } from "./debridement/components/DebridementEditMode";
import { DebridementViewMode } from "./debridement/components/DebridementViewMode";
import constants from "../../../../constants/constants.json";
import { SectionBanners } from "../../../secondary";

export const Debridement = ({ interventionId, assessmentDetails, formularyId }) => {
  const hook = useDebridement({ interventionId, formularyId });

  const shared = {
    careSetting: hook.careSetting,
    prerequisites: hook.prerequisites,
    flags: hook.flags,
    hideButtons: hook.hideButtons,
    isReadOnly: hook.isReadOnly,
    hasPermission: hook.hasPermission,
    noDataMsg: hook.noDataMsg,
  };

  return (
    <>
      {hook.confirmationModal && (
        <ConfirmationModal message={constants.confirmation} onClose={hook.confirmationClose} onConfirm={hook.yesConfirmationModalClick} />
      )}

      <SectionBanners />

      <div>
        {hook.editable ? (
          <DebridementEditMode
            assessmentDetails={assessmentDetails}
            handleSubmit={hook.handleSubmit}
            doSubmit={hook.doSubmit}
            register={hook.register}
            errors={hook.errors}
            control={hook.control}
            setFormChangesConfirm={hook.setFormChangesConfirm}
            form={hook.form}
            readiness={hook.readiness}
            reasonGaps={hook.reasonGaps}
            showReasonErrors={hook.showReasonErrors}
            performed={hook.performed}
            showApproach={hook.showApproach}
            showSubcutaneous={hook.showSubcutaneous}
            showPressure={hook.showPressure}
            readyOpen={hook.readyOpen}
            setReadyOpen={hook.setReadyOpen}
            setField={hook.setField}
            toggleMulti={hook.toggleMulti}
            setPrerequisiteAnswer={hook.setPrerequisiteAnswer}
            setPrerequisiteSelection={hook.setPrerequisiteSelection}
            setPrerequisiteReason={hook.setPrerequisiteReason}
            onCancelClick={hook.handleCancelClick}
            instrumentsUsedRef={hook.instrumentsUsedRef}
            necroticTissueRef={hook.necroticTissueRef}
            onMultiSelect={hook.handleMultiSelect}
            submitLoading={hook.submitLoading}
            {...shared}
          />
        ) : (
          <DebridementViewMode
            resp={hook.resp}
            assessmentDetails={assessmentDetails}
            onEdit={hook.editMode}
            viewLoading={hook.viewLoading}
            {...shared}
          />
        )}
      </div>
    </>
  );
};
